import { useRef, useEffect, useState, useMemo } from 'react'

import { EraserFill, PenFill } from 'react-bootstrap-icons'
import { useLocation } from 'react-router-dom'
import SignatureCanvas from 'react-signature-canvas'
import { toast } from 'react-toastify'

import rotatePng from '../../assets/rotate.png'

import { CustomButton } from '../../components/CustomButton'

import apinode from '../../services/api'

import { isPhone } from '../../utils/isPhone'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'

import { Container, Footer, Image, Signable } from './styles'
import './styles.css'

export function SignatureOrder() {
  const [orderNumber, setOrderNumber] = useState('')
  const [isRequestLoading, setIsRequestLoading] = useState(false)

  const { search } = useLocation()
  const searchParam = useMemo(() => new URLSearchParams(search), [search])

  let signatureCanvasRef = useRef(null)

  async function handleSaveSignature() {
    try {
      setIsRequestLoading(true)

      const image = signatureCanvasRef.current
        ?.getTrimmedCanvas()
        .toDataURL('image/png')

      const conta = searchParam.get('conta')

      const response = await apinode.post('/pedido/signature', {
        order: orderNumber,
        conta,
        image,
      })

      toast.success(response.data.message)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível gravar a assinatura!')
    } finally {
      setIsRequestLoading(false)
    }
  }

  useEffect(() => {
    const order = searchParam.get('order')

    setOrderNumber(order)
  }, [searchParam])

  return (
    <>
      <Container>
        {isPhone ? (
          <>
            <Footer>
              <CustomButton
                title="Apagar"
                color="#f31111"
                onClick={() => signatureCanvasRef.current?.clear()}
              >
                <EraserFill />
              </CustomButton>

              <CustomButton
                title={`Assinar Pedido ${orderNumber}`}
                color="#008a06"
                onClick={handleSaveSignature}
                isLoading={isRequestLoading}
                isLoadingText="Assinando..."
              >
                <PenFill />
              </CustomButton>
            </Footer>

            <Signable>
              <SignatureCanvas
                ref={(ref) => {
                  signatureCanvasRef.current = ref
                }}
                canvasProps={{
                  className: 'sigCanvas',
                }}
              />
            </Signable>

            <Image
              src={rotatePng}
              alt=""
            />
          </>
        ) : (
          <>
            <Signable>
              <SignatureCanvas
                ref={(ref) => {
                  signatureCanvasRef.current = ref
                }}
                canvasProps={{
                  className: 'sigCanvas',
                }}
              />
            </Signable>

            <Footer>
              <CustomButton
                title="Apagar"
                color="#f31111"
                onClick={() => signatureCanvasRef.current?.clear()}
              >
                <EraserFill />
              </CustomButton>

              <CustomButton
                title={`Assinar Pedido ${orderNumber}`}
                color="#008a06"
                onClick={handleSaveSignature}
                isLoading={isRequestLoading}
                isLoadingText="Assinando..."
              >
                <PenFill />
              </CustomButton>
            </Footer>
          </>
        )}
      </Container>
    </>
  )
}
